import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { manufacturingData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function ManufacturingPage() {
    return <SolutionTemplate {...manufacturingData} />;
}
